export interface IPaymentPlanSetupRequest {
    balanceToForward: number,
    agreedNumberOfPayments: number,
    agreedMonthlyPaymentAmount: number,
    agreedUpfrontPaymentAmount: number,
}

export class PaymentPlanSetupRequest implements IPaymentPlanSetupRequest {
    balanceToForward: number;
    agreedNumberOfPayments: number;
    agreedMonthlyPaymentAmount: number;
    agreedUpfrontPaymentAmount: number;
}